import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";

import HeroSection from "./HeroSection";

const AdvancedTrackingSection = lazy(() => import("./AdvancedTrackingSection"));
const BenefitSection = lazy(() => import("./BenefitSection"));
const OperationalTrackingSection = lazy(
  () => import("./OperationalTrackingSection"),
);
const KeyDriverSection = lazy(() => import("./KeyDriverSection"));
const LogisticsImpactSection = lazy(() => import("./LogisticsImpactSection"));

const Logistics = () => {
  return (
    <>
      <Helmet>
        <title>
          Supply Chain & Logistics Solutions | Real-Time Tracking & Operational
          Efficiency
        </title>
        <meta
          name="description"
          content="MAWALOG adapts to every industry, delImprove visibility, enhance operational efficiency, reduce costs and deliver superior customer experiences through real-time tracking, automation, digitalization and sustainable practices. "
        />

        <meta
          name="keywords"
          content=" LENTERA logistics services, logistics visibility, customer-centric logistics, global supply chain management. "
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <AdvancedTrackingSection />
        <BenefitSection />
        <OperationalTrackingSection />
        <KeyDriverSection />
        <LogisticsImpactSection />
      </Suspense>
    </>
  );
};

export default Logistics;
